import React from 'react';
import { ButtonProps } from '@mui/material';
import { StyledButton } from './Button.styles';

type Props = ButtonProps;

export const Button = ({ ...rest }: Props) => {
  return <StyledButton {...rest} />;
};
